const loadContactsFactory =
  () =>
  (
    $resource: ng.resource.IResourceService,
    $scope: ng.IScope & {
      isEmpty(obj: any): boolean;
      reps: todo[];
      listingContacts: Record<string, todo>;
      repsById: Record<string, todo>;
      contactsLoaded: boolean;
    },
    $q: ng.IQService,
    listingId: string,
    userIds: string[],
  ) => {
    const promises = [
      $resource<todo[]>('/user/full').query({ userIds }).$promise,
      $resource('/appointments/:listingId/config/contacts').get({
        listingId,
      }).$promise,
    ] as const;

    $scope.isEmpty = obj => {
      let isEmpty = true;
      if (!obj) return isEmpty;

      Object.keys(obj).forEach(key => {
        if (obj[key]) isEmpty = false;
      });

      return isEmpty;
    };

    return $q
      .all(promises)
      .then(result => {
        [$scope.reps, $scope.listingContacts] = result;
        $scope.repsById = {};
        $scope.reps.forEach(rep => {
          $scope.repsById[rep.id] = rep;
        });
        $scope.repsById = Object.assign(
          $scope.repsById,
          $scope.listingContacts,
        );
      })
      .then(() => {
        $scope.contactsLoaded = true;
      });
  };

export default loadContactsFactory;
